import React from "react";
import { HomeIcon, ChevronRightIcon } from "@heroicons/react/solid";

export interface BreadCrumbsComponent {
  firstLevel: string;
  secondLevel: string;
  thirdLevel?: string;
  mainHeading: string;
}

export default function BreadCrumbsComponent(props: BreadCrumbsComponent) {
  return (
    <div className="py-4 px-4 md:px-6 bg-gray-50 border-b overflow-hidden">
      <div className="relative items-center max-w-xl mx-auto md:max-w-7xl">
        <div className="relative flex items-center text-sm">
          <HomeIcon width="20" className="mr-3.5 md:mr-2 mb-1" />
          <div>{props.firstLevel}</div>
          <div className="hidden md:block">
            <ChevronRightIcon height="20" width="20" />
          </div>
          <div className="block md:hidden mx-4 md:mx-0">
            <ChevronRightIcon height="15" width="15" />
          </div>
          <div className="text-gray-500 text-xs md:text-sm leading-4 lg:leading-[initial] lg:text-[initial]">
            {props.secondLevel}
          </div>
          {props.thirdLevel && (
            <>
              <div className="hidden md:block">
                <ChevronRightIcon height="20" width="20" />
              </div>
              <div className="md:hidden mx-4 md:mx-0">
                <ChevronRightIcon height="15" width="15" />
              </div>
              <div className="text-gray-500 text-xs">{props.thirdLevel}</div>
            </>
          )}
        </div>
        <div className="text-xl mt-3 md:mt-[initial] leading-8 md:leading-[initial] md:text-3xl font-bold">
          {props.mainHeading}
        </div>
      </div>
    </div>
  );
}
